// extracted by mini-css-extract-plugin
export default {"mCard":"OA-z","image":"PA-z","imageNoBackground":"QA-z","imageHasCategory":"RA-z","fullWidth":"SA-z"};